import React, { Component } from 'react';
import swal from 'sweetalert';
import { toast } from "react-toastify";
import Tooltip from 'react-bootstrap/Tooltip';
import { GoChecklist } from "react-icons/go";
import { PiArrowsOutThin } from "react-icons/pi";
import AddSharpIcon from "@material-ui/icons/AddSharp";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import CachedSharpIcon from "@material-ui/icons/CachedSharp";
import VisibilitySharpIcon from '@material-ui/icons/VisibilitySharp';
import { Button, Form, Table, Image, Tabs, Tab } from 'react-bootstrap';
import axios from '../../../../axios';
import apiError from '../../../../error';
import { getDate } from '../../../../function';
import swalAlert from '../../../../swalFunction';
import PreviewThumbnail from '../../../preview/preview';
import Loader from '../../../loader/loader';
import TestEmails from '../../../test-campaign-email/test-campaign-email';
import LaunchNewModal from '../../../launch-modal/launch-new-modal';
import { collectTemplateCourseIds } from '../../../create-template/collect-template-course-ids';
import './preview.css';

// Shallow copy of src/component/create-template/preview/preview.js, adapted for
// the AI campaign-template editor. The display/conditional-rendering logic is
// kept identical; only the import paths and the `nextPath` fallback differ so
// the component works inside the AI side-panel (which has no router prop).
export default class Preview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: '',
            page: null,
            game: null,
            user: null,
            emails: '',
            categoryId: '',
            loading: false,
            template: null,
            category: null,
            language: null,
            subject: null,
            training: null,
            attackType: null,
            showModal: false,
            landing_url: null,
            campaignName: null,
            from_address: null,
            simulationType: null,
            showTestModal: false,
            refreshLoading: false,
            credential_harvesting: false,
            status: null,
            templateName: null,
            brodcastName: null,
            imageURL: '',
            courseName: '',
            previewURL: '',
            lmsCourses: [],
            courseIds: [],
            myWindow: null,
            templateImg: '',
            showLaunchNewModal: false,
            targetInteractionType: "inbound",
            isAIbased: false,
        }
    }

    componentDidMount = () => {
        this.handleRefresh();
    }

    // Falls back to a plain navigation when no `nextPath` prop is supplied
    // (the AI editor panel may render this component without a router).
    goToPath = (path) => {
        if (typeof this.props.nextPath === 'function') {
            this.props.nextPath(path);
        } else if (typeof this.props.onClose === 'function') {
            this.props.onClose();
        } else if (path) {
            window.location.href = path;
        }
    }

    // Called after the template is finished. In the AI editor we hand the
    // finished template back to the chat (id + name) instead of navigating to
    // the templates page; only the standalone usage falls back to navigation.
    afterFinish = () => {
        if (typeof this.props.onFinish === 'function') {
            this.props.onFinish({
                id: this.props.campaignTemplateId,
                name: this.state.campaignName,
            });
        } else {
            this.goToPath('/templates');
        }
    }

    handleRefresh = () => {
        if (this.props.campaignTemplateId) {
            this.setState({ refreshLoading: true })
            axios.get('/api/campaign/template/preview/' + this.props.campaignTemplateId, {})
                .then(res => {
                    var campaignTemplate = res.data.campaign_template;
                    const courseIds = collectTemplateCourseIds(campaignTemplate);
                    this.setState({
                        loading: false,
                        user: res.data.user,
                        refreshLoading: false,
                        pageImg: res.data.pagePath,
                        game: campaignTemplate.game,
                        type: campaignTemplate.type,
                        templateImg: res.data.templatePath,
                        campaignName: campaignTemplate.name,
                        training: campaignTemplate.courseId,
                        awarenessPath: res.data.awarenessPath,
                        credential_harvesting: campaignTemplate.credential_harvesting,
                        from_address: campaignTemplate.sender ? campaignTemplate.sender.from_address : null,

                        subject: campaignTemplate.template ? campaignTemplate.template.subject : null,
                        emailTracking: campaignTemplate.template ? campaignTemplate.template.emailTracking : null,

                        templateName: campaignTemplate.template ? campaignTemplate.template.templateName : null,
                        brodcastName: campaignTemplate.template ? campaignTemplate.template.brodcastName : null,
                        status: campaignTemplate.status,

                        category: campaignTemplate.category ? campaignTemplate.category.name : null,
                        categoryId: campaignTemplate.category ? campaignTemplate.category.id : null,
                        language: campaignTemplate.language ? campaignTemplate.language.name : null,
                        attackType: campaignTemplate.attack_type ? campaignTemplate.attack_type.name : null,
                        simulationType: campaignTemplate.simulation_type ? campaignTemplate.simulation_type.name : {},

                        landing_url: campaignTemplate.page ? campaignTemplate.page.landing_url : null,
                        capture_passwords: campaignTemplate.page ? campaignTemplate.page.capture_passwords : null,
                        capture_credentials: campaignTemplate.page ? campaignTemplate.page.capture_credentials : null,
                        awarenessUrl: res.data.awarenessUrl,

                        targetInteractionType: campaignTemplate.targetInteractionType,
                        isAIbased: campaignTemplate.isAIbased,

                        firstname: '',
                        lastname: '',
                        courseIds,
                        lmsCourses: [],
                        imageURL: '',
                        previewURL: '',
                    }, () => {
                        if (courseIds.length) {
                            this.loadCourseLMS();
                        }
                    })
                })
                .catch(error => {
                    this.setState({ refreshLoading: false })
                    apiError(error)
                })
        }
    }

    shareCampaignTempalte = () => {
        swal({
            title: "Do you want to share this template?",
            icon: "info",
            buttons: ['Not Now!', 'Yes'],
        })
            .then(willSuccess => {
                if (willSuccess) {
                    if (this.props.campaignTemplateId) {
                        axios.post('/api/campaign/template/share/' + this.props.campaignTemplateId, {})
                            .then(res => {
                                toast.success("Campaign Tempate Share Successfully");
                            })
                            .catch(err => {
                                apiError();
                            })
                    }
                }
            })
    }

    handleFinish = () => {
        swal({
            timer: 1000,
            buttons: false,
            icon: "success",
            text: '---',
            title: "Campaign Template Finished Successfully",
        })
        .then(() => {
            if (this.props.campaignTemplateId) {
                axios.post('/api/campaign/template/finish/' + this.props.campaignTemplateId, {})
                    .then(res => {
                        toast.success("Campaign template finished successfully");
                        this.afterFinish();
                    })
                    .catch(error => {
                        apiError(error);
                    })
            } else {
                this.afterFinish();
            }
        })
    }

    showHandleThumbnail = (type) => {
        let previewSrc = '';
        if (type === 'template') {
            previewSrc = this.state['templateImg'];
        } else if (type === 'page') {
            previewSrc = this.state['pageImg'];
        } else if (type === 'awareness') {
            previewSrc = this.state['awarenessPath'];
        }
        this.setState({ showModal: !this.state.showModal, previewSrc: previewSrc, previewType: type });
    }

    launchCampaignTemplate = () => {
        this.setState({showLaunchNewModal: true});
    }

    showHandleTestEmail = () => {
        this.setState({ showTestModal: !this.state.showTestModal });
    }

    testCampaign = (targetDetails) => {
        if (this.props.campaignTemplateId && this.props.campaignTemplateId !== 0 && this.props.campaignTemplateId !== '0') {
            this.setState({ loading: true })
            axios.post('/api/simulation/test', {
                targetDetails,
                campaignTemplateId: this.props.campaignTemplateId,
            })
                .then(res => {
                    this.showHandleTestEmail();
                    this.setState({ loading: false });
                    toast.success("Test campaign run successfully");
                    setTimeout(() => { window.open('/campaign/test-results/?attackTypeId=' + this.state.attackType) }, 1500);
                })
                .catch(error => {
                    this.setState({ loading: false })
                    apiError(error);
                })
        }
        else toast.error("Invalid Campaign Template");
    }
    loadCourseLMS = () => {
        const courseIds = this.state.courseIds;
        if (!courseIds || !courseIds.length) return;
        this.setState({ loading: true });
        axios.get('/api/lms/course-detail', {
            params: {
                courseIds,
            }
        })
            .then(res => {
                const courses = Array.isArray(res.data?.courses) ? res.data.courses : [];
                var courseName = {};
                for (let i = 0; i < courses.length; i++) {
                    courseName[courses[i].id] = courses[i].name;
                }
                this.setState({
                    loading: false,
                    courseName: courseName,
                    imageURL: res.data.imageURL || '',
                    lmsCourses: courses,
                    previewURL: res.data.previewURL || '',
                });
            })
            .catch(err => {
                this.setState({ loading: false });
                apiError(err)
            })
    }

    handleLMS = async (courseId) => {
        document.body.style.cursor = "wait";
        axios.get('/api/lms', {
            params: {
                url: `${this.state.previewURL}${courseId}?r=Sw4s56g`
            }
        })
            .then(res => {
                document.body.style.cursor = "";
                const allowedBaseURL = process.env.REACT_APP_LMS_URL;
				const allowedDomain = new URL(allowedBaseURL).hostname;
				const url = new URL(res.data.url);

				const allowedDomainParts = allowedDomain.split('.').slice(-2).join('.');
				const urlDomainParts = url.hostname.split('.').slice(-2).join('.');

				// Validate domain
				if (urlDomainParts !== allowedDomainParts) {
					swalAlert("Security Alert", "Invalid redirect URL detected!", "error");
					return;
				}

				// Prevent Open Redirection
				const redirectUrl = url.searchParams.get("url"); // Potential redirection target
				if (redirectUrl) {
					try {
						const parsedRedirectUrl = new URL(redirectUrl, allowedBaseURL); // Resolve relative paths
						const redirectDomainParts = parsedRedirectUrl.hostname.split('.').slice(-2).join('.');

						if (redirectDomainParts !== allowedDomainParts) {
							swalAlert("Security Alert", "Invalid redirect target detected!", "error");
							return;
						}
					} catch (error) {
						console.log("Invalid redirect URL detected:", error);
						swalAlert("Security Alert", "Invalid redirect target detected!", "error");
						return;
					}
				}
                window.open(res.data.url, '_blank');
            })
            .catch(err => {
                apiError(err);
                document.body.style.cursor = "";
            });
    }

    render() {
        const isAiWhatsapp = this.state.attackType === 'WhatsApp' && this.state.targetInteractionType === 'inbound' && this.state.isAIbased === true;
        const isNormalWhatsapp = this.state.attackType === 'WhatsApp' && !isAiWhatsapp;
        return (
            <div className="acp-preview">
                <div className="tabContent-block email-template-wrap previewSection" id="preview">

                    <div className='rightSectionHeader'>
                        <div className="row justify-content-between d-flex align-items-center">
                            <div className="col-md-4 tab-right-header">
                                <h6>Preview</h6>
                                <p>Preview complete template before saving</p>
                            </div>
                            <div className="col-md-8 text-right">
                                <div className="btn-container justify-content-end d-flex align-items-center">
                                        <div className="col-md-9 text-right pr-0">
                                            <div className="btn-container justify-content-end d-flex align-items-center">
                                                <Button className="commonrefreshBtn mr-2" onClick={this.handleRefresh}><CachedSharpIcon className="btn-icon" /></Button>
                                                {/* <Button variant="primary" className="text-right mr-2" onClick={() => {
                                                    if (this.props.campaignTemplateId) {
                                                        axios.post('/api/campaign/template/finish/' + this.props.campaignTemplateId, {})
                                                            .then(res => {
                                                            })
                                                            .catch(error => {
                                                                apiError(error);
                                                            })
                                                    }
                                                    this.launchCampaignTemplate()
                                                }}><AddSharpIcon className="btn-icon"></AddSharpIcon> Create Campaign </Button> */}

                                                    {!this.props.readOnly &&
                                                    <OverlayTrigger
                                                        placement='top'
                                                        overlay={<Tooltip id='top'>Overall view of campaign template</Tooltip>}>
                                                        <Button variant="primary" type="button" onClick={() => {
                                                            if (this.props.campaignTemplateId) {
                                                                axios.post('/api/campaign/template/finish/' + this.props.campaignTemplateId, {})
                                                                    .then(res => {
                                                                    })
                                                                    .catch(error => {
                                                                        apiError(error);
                                                                    })
                                                            }
                                                            this.showHandleTestEmail();
                                                        }} ><GoChecklist className="btn-icon"></GoChecklist> Test Template</Button>
                                                    </OverlayTrigger>
                                                    }
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='templateDetailsWrapper'>
                        <div className='row'>
                            <div className="col-md-6 pl-0">
                                <div className='templateList'>
                                    <Table>
                                        <tbody>
                                            {this.state.campaignName ?
                                                <tr>
                                                    <td className='keyHeading'>Template Name:</td>
                                                    <td className='valueHeading'>{this.state.campaignName}</td>
                                                </tr> : ""
                                            }

                                            {this.state.category ?
                                                <tr>
                                                    <td className='keyHeading'>Template Category: </td>
                                                    <td className='valueHeading'><span className="badgeYn p-badge">{this.state.category}</span></td>
                                                </tr> : ""
                                            }

                                            {this.state.from_address && !isNormalWhatsapp && this.state.attackType !== "Telegram" ?
                                                <tr>
                                                    <td className='keyHeading'>From :</td>
                                                    <td className='valueHeading'>{this.state.from_address}</td>
                                                </tr> : ""
                                            }

                                        </tbody>
                                    </Table>

                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className='templateList'>
                                    <Table>
                                        <tbody>
                                            <tr>
                                                <td className='keyHeading'>Language :</td>
                                                <td className='valueHeading'>{this.state.language}</td>
                                            </tr>

                                            <tr>
                                                <td className='keyHeading'>Type of Simulation :</td>
                                                <td className='valueHeading'>{this.state.simulationType}</td>
                                            </tr>

                                            <tr>
                                                <td className='keyHeading'>Attack Vector :</td>
                                                <td className='valueHeading'>{this.state.attackType}</td>
                                            </tr>
                                            <tr>
                                                {!(this.state.attackType === 'Vishing' && this.state.targetInteractionType==="outbound") && (this.state.attackType !== 'Training + Quiz' && this.state.attackType !== 'Attachment' && this.state.attackType !== "Ransomware") ?
                                                    <>
                                                        <td className='keyHeading'>Credential Harvesting : </td>
                                                        <td className='valueHeading'>{this.state.credential_harvesting ? <p className="badgeYn yes-badge">Yes</p> : <p className="badgeYn no-badges">No</p>}</td>
                                                    </> : ''
                                                }
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>

                    {!(this.state.attackType === 'Vishing' && this.state.targetInteractionType==="outbound") && (this.state.attackType !== 'Training + Quiz') ?
                        <div className='tabTamplate new-template-tabs'>
                            <Tabs
                                activeKey={this.state.tab === "training" && this.state.simulationType !== "Simulation Attack + Training" ? "simulation" : this.state.tab}
                                onSelect={(tab) => {
                                    if (tab === "training" && this.state.simulationType !== "Simulation Attack + Training") {
                                        return;
                                    }
                                    this.setState({ tab: tab });
                                }}
                            >
                                <Tab eventKey="simulation" title="Simulation">
                                    <div className="row">
                                        <div className="col-md-4 pl-0">
                                            <div className='contHeading'>
                                                <h6>{(isNormalWhatsapp || this.state.attackType === "Telegram") ? <Form.Label>Message Template  </Form.Label> : <Form.Label>Email Template  </Form.Label>}</h6>
                                            </div>
                                            {isNormalWhatsapp ?
                                                <>
                                                    <div className="bg-light p-3 mb-3">
                                                        <h6>Template Name</h6>
                                                        <p className="mb-0">{this.state.templateName}</p>
                                                    </div>
                                                    {this.state.brodcastName &&
                                                        <div className="bg-light p-3 mb-3">
                                                            <h6>Broadcast Name</h6>
                                                            <p className="mb-0">{this.state.brodcastName}</p>
                                                        </div>
                                                    }
                                                </> :

                                                <div className="img-hover-wrap templateView">
                                                    <div className='cardImg'>
                                                        <img src={this.state.templateImg} alt="template" className="img-fluid img"></img>
                                                        <div className='hover-btn'>
                                                            <PiArrowsOutThin className="btn-icon" onClick={e => this.showHandleThumbnail('template')} />
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        {this.state.attackType !== 'Vishing' &&
                                        <>
                                            {this.state.credential_harvesting && !isAiWhatsapp ?
                                                <div className="col-md-4">
                                                    <div className='contHeading'>
                                                        <h6>Landing Page</h6>
                                                    </div>
                                                    <div className="img-hover-wrap templateView">
                                                        <div className='cardImg'>
                                                            <img src={this.state.pageImg} alt="template" className="img-fluid img"></img>
                                                            <div className='hover-btn'>
                                                                <PiArrowsOutThin onClick={e => this.showHandleThumbnail('page')} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> : null
                                            }
                                            {this.state.attackType !== "Ransomware" && !isAiWhatsapp &&
                                                <div className="col-md-4">
                                                    <div className='contHeading'>
                                                        <h6>Awareness Page</h6>
                                                    </div>

                                                    <div className="img-hover-wrap templateView">
                                                        <div className='cardImg'>
                                                            <img src={this.state.awarenessPath} alt="template" className="img-fluid img"></img>
                                                            <div className='hover-btn'>
                                                                <PiArrowsOutThin onClick={e => {
                                                                    this.showHandleThumbnail('awareness')
                                                                }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </>}
                                    </div>


                                    <div className='url-wrapper'>
                                        <div className="row">
                                            <div className='col-md-4'>
                                                {this.state.attackType !== 'Telegram' && !isNormalWhatsapp ?
                                                    <>
                                                        <div className='contHeading'>
                                                            <h6>Subject </h6>
                                                            <p className="mb-0">{this.state.subject}</p>
                                                        </div>

                                                        <div className='contHeading'>
                                                            <h6>Attacker Profile </h6>
                                                            <p className="mb-0">Sender ID : {this.state.from_address}</p>
                                                        </div>
                                                    </>: null
                                                }
                                            </div>
                                            {this.state.attackType !== "Vishing" &&
                                            <>
                                                {this.state.credential_harvesting && !isAiWhatsapp ?
                                                    <div className="col-md-4">
                                                        <div className='contHeading'>
                                                            <h6>URL</h6>
                                                            <p>{!this.state.landing_url ? "No URL Found" : this.state.landing_url}</p>
                                                        </div>
                                                        {
                                                            this.state.attackType !== "Ransomware" && <Table>
                                                            <tbody>
                                                                <tr>
                                                                    <td className='keyHeading'>Capture Credential</td>
                                                                    <td className='valueHeading'> {this.state.capture_credentials ? <p className="badgeYn yes-badges">Yes</p> : <p className="badgeYn no-badges">No</p>}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td className='keyHeading'>Capture Password </td>
                                                                    <td className='valueHeading'>{this.state.capture_passwords ? <p className="badgeYn yes-badges">Yes</p> : <p className="badgeYn no-badges">No</p>}</td>
                                                                </tr>

                                                            </tbody>
                                                        </Table>
                                                        }


                                                    </div> : null
                                                }
                                                {this.state.attackType !== "Ransomware" && !isAiWhatsapp &&
                                                    <div className='col-md-4'>
                                                        <div className='contHeading'>
                                                            <h6>URL </h6>
                                                            <p className="mb-0">{this.state.awarenessUrl}</p>
                                                        </div>
                                                    </div>
                                                }
                                            </>}
                                        </div>
                                    </div>
                                </Tab>
                                <Tab
                                    eventKey="training"
                                    title="Training"
                                    disabled={this.state.simulationType !== "Simulation Attack + Training"}
                                >
                                        <div className='contHeading'>
                                            <h6>Training </h6>
                                        </div>
                                        <div className="tableContainerWrapInner">
                                            <Table className="training-table" borderless>
                                                <thead>
                                                    <tr>
                                                        <th>Course</th>
                                                        <th>Date</th>
                                                        <th>Lectures</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {this.state.lmsCourses.length === 0 ? (
                                                        <tr>
                                                            <td colSpan={6} className="text-muted text-center py-3">
                                                                No training courses linked to this template.
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                    {this.state.lmsCourses.map((course, index) => {
                                                        return <tr key={course.id != null ? course.id : index} className="setcheckBox">
                                                            <td>
                                                                <div className="onlyForPinter">
                                                                    <div className="flexTableData">
                                                                        <div className="companyLogoIcon">
                                                                            <Image src={this.state.imageURL + course.logo} alt="no image" className="training-img"></Image>
                                                                        </div>

                                                                        <div>
                                                                            <p>{course.name}</p>
                                                                            <p>{course.courseType}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>{getDate(course.createdAt)}</td>
                                                            <td>{course.totalLecture}</td>

                                                            <td>{course.status}</td>
                                                            <td><VisibilitySharpIcon className="btn-icon training-preview-icon" onClick={e => this.handleLMS(course.id)} ></VisibilitySharpIcon></td>
                                                        </tr>
                                                    })}
                                                </tbody>
                                            </Table>

                                        </div>
                                    </Tab>
                            </Tabs>
                        </div> : null
                    }
                </div>
                {!this.props.readOnly &&
                <div className=" mt-2">
                        <div className='footer-wrapper justify-content-end d-flex'>
                        <Button variant="success" type="button" className="text-white" onClick={this.handleFinish}>Done</Button>
                    </div>
                </div>
                }
                <PreviewThumbnail
                    src={this.state.previewSrc}
                    showModal={this.state.showModal}
                    attackType={this.state.attackType}
                    previewType={this.state.previewType}
                    showHandle={this.showHandleThumbnail}
                    html={this.state.selectedTeplate && this.state.selectedTeplate.template ? this.state.selectedTeplate.template.html : ''}
                ></PreviewThumbnail>

                <TestEmails
                    attackType={this.state.attackType}
                    targetInteractionType={this.state.targetInteractionType}
                    emails={this.state.emails}
                    firstname={this.state.firstname}
                    lastname={this.state.lastname}
                    nextPath={this.props.nextPath}
                    testCampaign={this.testCampaign}
                    showModal={this.state.showTestModal}
                    showHandle={this.showHandleTestEmail}
                    handleEmails={(e) => this.setState({ emails: e.target.value })}
                    handleFirstname={(e) => this.setState({ firstname: e.target.value })}
                    handleLastname={(e) => this.setState({ lastname: e.target.value })}
                ></TestEmails>

                <LaunchNewModal
                            showModal={this.state.showLaunchNewModal}
                            showHandle={() => this.setState({ showLaunchNewModal: false })}
                            nextPath={this.props.nextPath}
                            campaignTemplateId={this.props.campaignTemplateId}
                            attackType={this.state.attackType}
                            simulationType={this.state.simulationType}
                            credentialHarvesting={this.state.credential_harvesting}
                            categoryId={this.state.categoryId}
                            prefilledFromTemplate={!!(
                                this.state.attackType &&
                                this.props.campaignTemplateId
                            )}
                            targetInteractionType={this.state.targetInteractionType}
                            isAIbased={this.state.isAIbased}
                        />
                {this.state['loading'] ? <Loader /> : ''}
            </div>
        )
    }
}
